import { Card, Skeleton, Stack } from '@mantine/core';

type CardItemLoadingProps = {
  isFlashSale?: boolean;
};

export default function CardItemLoading({ isFlashSale }: CardItemLoadingProps) {
  return (
    <Card
      shadow={'sm'}
      radius={12}
      padding={0}
      mb={16}
      miw={isFlashSale ? 277 : 240}
      w="100%"
      h={289}
    >
      <Skeleton width="100%" miw={isFlashSale ? 277 : 240} height={126} />
      <Stack gap="sm" pt="md" px="xs">
        <Skeleton width={90} height={12} />
        <Skeleton width={180} height={36} />
      </Stack>
    </Card>
  );
}
